/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.toolhealth.ToolHealthStatus
*/
export var ToolHealthStatus;
(function (ToolHealthStatus) {
    ToolHealthStatus["OK"] = "OK";
    ToolHealthStatus["DEGRADED"] = "DEGRADED";
    ToolHealthStatus["DOWN"] = "DOWN";
})(ToolHealthStatus || (ToolHealthStatus = {}));
//# sourceMappingURL=ToolHealthStatus.js.map